import { CircularProgress, Typography, useTheme } from '@mui/material';
import { Chip } from '@shared/components';

interface Props {
  label: string | number;
  size?: 'medium' | 'small';
  isLoading?: boolean;
}

export const InfoChip = ({ label, size = 'small', isLoading }: Props) => {
  const theme = useTheme();
  const { tint } = theme.vars.palette.semantic;
  return (
    <Chip
      size={size}
      backgroundColor={tint.sky.soft}
      textColor={tint.sky.text}
      sx={{ border: '1px solid', borderColor: 'divider' }}
      label={
        isLoading ? (
          <CircularProgress size={18} />
        ) : (
          <Typography variant="body2">{label}</Typography>
        )
      }
    />
  );
};
